// extracted by mini-css-extract-plugin
export var component = "WastePickupSearchResultsItem-module--component--N3olH";
export var loading = "WastePickupSearchResultsItem-module--loading--No5Qr";
export var downloadButton = "WastePickupSearchResultsItem-module--downloadButton--GH4rk";
export var downloadButtonText = "WastePickupSearchResultsItem-module--downloadButtonText--yuLhX";